'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (character, value) {
	if (character >= '0' && character <= '9') {
		return character;
	}
};
//# sourceMappingURL=parse digit.js.map


//////////////////
// WEBPACK FOOTER
// ./~/input-format/build/parse digit.js
// module id = 628
// module chunks = 1 2